import { AnlageassistentContextType } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import { createContext } from 'react';

export const AnlageassistentContext = createContext<
  {
    state: AnlageassistentContextType['state'];
    setState: React.Dispatch<
      React.SetStateAction<AnlageassistentContextType['state']>
    >;
  } & AnlageassistentContextType['contextHelpers']
>({
  validateStepReady: () => true,
  validateCurrentSubStep: () => {},
  navigateToSubStep: () => {},
  navigateToStep: () => {},
  next: () => {},
  previous: () => {},
  hasNext: () => false,
  hasPrevious: () => false,
  currentStepProgress: () => 0,
  getCurrentSubStep: () => null,
  resetDependentFields: () => {},

  state: {
    currentStepIndex: 0,
    currentSubStepIndex: 0,
    showGuttageStep: false,
    steps: [],
  },

  setState: () => {},
});
